export default __webpack_public_path__ + "static/media/img15.2c068d5d.jpg";